import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { RadiologyLiveIcon } from '@/components/icons/ProductIcons';

export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <nav
        className={cn(
          'transition-all duration-500',
          scrolled
            ? 'glass border-b border-border/30'
            : 'bg-transparent border-b border-transparent'
        )}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2">
              <RadiologyLiveIcon size={32} />
              <span className="text-xl font-bold">
                <span className="text-muted-foreground">RadiologyLive.ai</span>
              </span>
            </Link>

            {/* CTA Buttons — Desktop */}
            <div className="hidden md:flex items-center space-x-4">
              <Link to="/blog">
                <Button variant="ghost" size="sm">
                  Blog
                </Button>
              </Link>
              {/* Pricing hidden during beta — Stripe not wired up yet */}
              <Link to="/portal">
                <Button variant="ghost" size="sm">
                  Sign In
                </Button>
              </Link>
              <Link to="/waitlist">
                <Button size="sm" className="bg-primary hover:bg-primary/90">
                  Join the Waitlist
                </Button>
              </Link>
            </div>

            {/* Mobile menu button */}
            <button
              className="md:hidden p-2 text-muted-foreground hover:text-foreground"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div
          className={cn(
            'md:hidden overflow-hidden transition-all duration-300 ease-in-out',
            mobileMenuOpen ? 'max-h-48' : 'max-h-0'
          )}
        >
          <div className="px-4 py-4 space-y-2 bg-card/95 border-t border-border/30">
            <Link to="/blog" className="block" onClick={() => setMobileMenuOpen(false)}>
              <Button variant="ghost" className="w-full justify-start">
                Blog
              </Button>
            </Link>
            {/* Pricing hidden during beta */}
            <Link to="/portal" className="block" onClick={() => setMobileMenuOpen(false)}>
              <Button variant="ghost" className="w-full justify-start">
                Sign In
              </Button>
            </Link>
            <Link to="/waitlist" className="block" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full bg-primary hover:bg-primary/90">
                Join the Waitlist
              </Button>
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}
